<template>
  <div>
    <div class="tabs-left col-xs-12 p-24">
      <template>
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" class="nav-item" :class="{ active: activeName === 'expiry' }">
            <span class="nav-link" role="tab" @click="setTab('expiry')" data-toggle="tab">
              <img
                class="dashboard-icons"
                src="/static/images/market-place/icons/reg_tracker_icon.svg"
              />
              Expiry
            </span>
          </li>
          <li role="presentation" class="nav-item" :class="{ active: activeName === 'pending' }">
            <span @click="setTab('pending')" class="nav-link" role="tab" data-toggle="tab">
              <img
                class="dashboard-icons"
                src="/static/images/market-place/icons/reg_tracker_icon.svg"
              />
              Pending
            </span>
          </li>
        </ul>
      </template>
    </div>
    <div class="tab-content custom_tab_content">
      <div
        v-if="selectedMenu == 'expiry'"
        class="tab-pane expi_tab content_tab"
        :class="selectedMenu == 'expiry' ? 'active' : ''"
      >
        <div v-for="(item, key, index) in expirationDetails" :key="index">
          <p class="tab_expiry">
            <span v-if="key === 'expired'">Expired</span>
            <span v-if="key === 'month'">Expiring this month</span>
            <span v-if="key === 'quarter'">Expiring next 3 months</span>
            <span v-if="key === 'year'">Expiring this year</span>
            <span class="progress_count">{{ item.number }}</span>
          </p>
          <div class="progress">
            <div
              class="progress-bar"
              :class="{
                expired: key === 'expired',
                expiring_month: key === 'month',
                expiring_3months: key === 'quarter',
                expiring_year: key === 'year'
              }"
              :aria-valuenow="item.number"
              :aria-valuemin="0"
              :aria-valuemax="100"
              :style="{ width: item.number + '%' }"
            ></div>
          </div>
        </div>
      </div>
      <div
        v-else-if="selectedMenu == 'pending'"
        class="tab-pane pen_tab content_tab"
        :class="selectedMenu == 'pending' ? 'active' : ''"
      >
        <div v-for="(item, key, index) in pendingSummary" :key="index">
          <p class="tab_expiry">
            <span v-if="key === 'initial'">Initial Registrations</span>
            <span v-if="key === 'modification'">Modifications</span>
            <span v-if="key === 'renewal'">Renewals</span>
            <span class="progress_count">{{ item.number }}</span>
          </p>
          <div class="progress">
            <div
              class="progress-bar"
              :class="{
                initial: key === 'initial',
                modif: key === 'modification',
                renew: key === 'renewal'
              }"
              :aria-valuenow="item.number"
              :aria-valuemin="0"
              :aria-valuemax="100"
              :style="{ width: item.number + '%' }"
            ></div>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>

<script>
import $ from 'jquery';
import Loader from '../../../UIComponents/Loader.vue';
import EventBus from '../../../../utils/event-bus';
import { getDashboardSummary } from '../../../../apis/dashboard';

export default {
  props: {
    account_id: Number,
    roleId: Number,
    userId: Number
  },
  data() {
    return {
      activeName: 'expiry',
      selectedMenu: 'expiry',
      headlineIndex: 0,
      regulatoryHeadlines: [],
      expirationDetails: {},
      initialRegistrationsCount: 0,
      modificationsCount: 0,
      renewalsCount: 0,
      notificationsList: [],
      errors: [],
      notificationscount: 4,
      activeRegistration: {},
      upcomingRegistrations: [],
      loaderStatus: false,
      services: [],
      topTwoServices: [],
      showStaticRegistrations: false,
      pendingSummary: []
    };
  },

  components: {
    Loader
  },
  methods: {
    setTab(tab) {
      this.activeName = tab;
      this.selectedMenu = this.activeName;
    },
    /* getDashbaordSummary method
      to get the expiration and pending details */
    async getDashboardSummary() {
      const { expiration_details: expirationDetails, pending_summary: pendingSummary } =
        await getDashboardSummary();
      this.expirationDetails = expirationDetails;
      this.pendingSummary = pendingSummary;
    },
    /**
     * openAddPopup()
     * Open the modal popup
     */
    openAddPopup() {
      $('#addPopup').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    /**
     * openDeletePopup()
     * Open the modal popup
     */
    openDeletePopup() {
      $('#modal_delete').modal({
        backdrop: 'static',
        keyboard: false
      });
    },
    redirect(url) {
      this.$router.push(url);
      EventBus.$emit('activeMenuTitle', this.$route.meta.title);
    }
  },
  async created() {
    try {
      this.loaderStatus = true;
      await this.getDashboardSummary();
      this.loaderStatus = false;
    } catch (err) {
      this.loaderStatus = false;
    }
  }
};
</script>
<style scoped>
.expired {
  background: #eb5757;
}
.expiring_month {
  background: #f2994a;
}
.expiring_3months {
  background: #2f80ed;
}
.expiring_year {
  background: #27ae60;
}
.tab_expiry {
  font-size: 14px;
  line-height: 16px;
  margin-bottom: 7px;
}
.progress_count {
  float: right;
  font-size: 14px;
  line-height: 16px;
}
.progress {
  height: 10px;
  margin-bottom: 15px;
  background: #c4c4c4;
  box-shadow: none;
}
.initial {
  background: #27ae60;
}
.modif {
  background: #f2994a;
}
.renew {
  background: #2f80ed;
}
.content_tab {
  background: #ffffff;
  border-radius: 10px 10px 0px 0px;
  padding: 25px 25px 0px 25px;
}
.custom_tab_content {
  background: #0b3c6147;
  border-radius: 10px 10px 0px 0px;
}
.nav-tabs {
  border-bottom: none;
}
#exp_tab > .active {
  background-color: #fff !important;
  font-weight: 500;
  font-size: 18px;
}
.nav-tabs > li > a {
  background: transparent !important;
  margin-right: 0px;
  border: none;
  font-weight: 400;
  font-size: 22px;
  line-height: 24px;
  color: #ffffff;
  padding-top: 10px;
}

.active a {
  color: #0b3c61 !important;
}
.nav-tabs > li.active > a,
.nav-tabs > li.active > a:focus,
.nav-tabs > li.active > a:hover {
  border: none;
  font-weight: 500;
}
ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 14px;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
}
.icon-reg-combo {
  background-image: url(/static/images/icons/track_plus_icon.svg);
  background-size: 24px 24px;
  background-repeat: no-repeat;
  background-position-y: center;
  content: '';
  width: 24px;
  height: 24px;
  position: relative;
  padding-left: 30px;
}
.active .icon-reg-combo {
  background-image: url(/static/images/icons/track_plus_icon_blue.svg);
}
/* ul.nav-tabs > li {
  margin-right: 40px;
  padding-bottom: 14px;
  font-size: 22px;
  font-weight: 500;
  line-height: 26px;
} */

ul.nav-tabs li.active {
  color: #0b3c61;
}
@media only screen and (max-width: 767px) {
  ul.nav-tabs > li {
    margin-right: 18px;
    padding-bottom: 14px;
  }
}

.p-24 {
  padding: 24px;
}
</style>
